import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if ('target' in node) {
    const target = node.getAttribute('target');
    if (target !== '_blank') {
      node.removeAttribute('target');
      node.removeAttribute('rel');
    } else {
      node.setAttribute('rel', 'noreferrer');
    }
  }
});

export function sanitizeHTML(markup: string): string {
  return DOMPurify.sanitize(markup, { ADD_ATTR: ['target', 'rel'] });
}

const escapedHtmlChars: { [key: string]: string } = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&apos;',
};

const unsafeHtmlCharsRegex = new RegExp(`[${Object.keys(escapedHtmlChars).join('')}]`, 'g');

export function escapeHtml(str: string): string {
  return str === undefined || str === null
    ? ''
    : str.replace(unsafeHtmlCharsRegex, (unsafeChar) => escapedHtmlChars[unsafeChar]);
}
